import { PostModel } from "common/models/baseModel";
import { create } from "zustand";

import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { IJobPostingGridFilter } from "../api/types";

export interface JobPostingStore {
  postModel: PostModel<IJobPostingGridFilter>;
  handleFiltering: (filter: IJobPostingGridFilter) => void;
  handlePagination: (pageModel: GridPaginationModel) => void;
  handleSorting: (sortModel: GridSortModel) => void;
}

const useJobPostingStore = create<JobPostingStore>()((set) => ({
  postModel: {
    pagingModel: {
      page: 0,
      pageSize: 100,
    },
    filterModel: {
      jobTitle: null,
      memberName: null,
      companyName: null,
      jobType: null,
      employementType: null,
      verificationStatus: null,
      jobPostDate: null,
      city: null,
      countryID: null,
    },
  },
  handlePagination: (pageModel: GridPaginationModel) =>
    set((state) => ({
      postModel: { ...state.postModel, pagingModel: { ...pageModel } },
    })),
  handleFiltering: (filterModel: IJobPostingGridFilter) =>
    set((state) => ({
      postModel: { ...state.postModel, filterModel: { ...filterModel } },
    })),
  handleSorting: (sortModel: GridSortModel) =>
    set((state) => ({
      postModel: { ...state.postModel, sortModel: [...sortModel] },
    })),
}));

export default useJobPostingStore;
